export const serviceRequestAppName = 'Request Management';
